import React from 'react';
import { getCategories } from '../../store/categories/categories-selectors';
import CategoryDrawer from '../category-drawer';
import { HeaderMobile } from '../header';
import { useSelector } from '../runtime-context';

const CategoryMobileHeader = () => {
  const categories = useSelector(getCategories);

  if (categories.length) {
    return <HeaderMobile menu={<CategoryDrawer />} />;
  }

  return <HeaderMobile />;
};

export default CategoryMobileHeader;
